export const modelsParams = {
	orderBy: 'id',
};
